// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Turks & Caicos Islands */
const TC = /^(?:649(?:2(?:3[129]|4[1-79])|3\d\d|4[34][1-3])\d{4})$/;

export default TC;
